export default "__VITE_ASSET__CPnSKu3e__"